import { render, staticRenderFns } from "./CampCallDetails.vue?vue&type=template&id=19bec0b4&"
import script from "./CampCallDetails.vue?vue&type=script&lang=js&"
export * from "./CampCallDetails.vue?vue&type=script&lang=js&"
import style0 from "./CampCallDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports